module.exports = __webpack_public_path__ + "@/assets/img/IPP_Logo@3x.fc0811e5.png";